(function () {
    'use strict';

    angular
        .module('employeeControllers')
        .controller('EmployeeContactInfoPrimaryController', Controller);

    Controller.$inject = ['$scope'];

    function Controller($scope) {

        // Toggle Direct Line 
        $scope.toggleDirectLine = function () {
            $scope.employeeWithLocations.IamDirectLine = !$scope.employeeWithLocations.IamDirectLine;
            $scope.pageIsDirty();
        };

        // Toggle Is Public Mobile Phone
        $scope.toggleIsPublicMobilePhone = function () {
            $scope.employeeWithLocations.IamIsPublicMobilePhone = !$scope.employeeWithLocations.IamIsPublicMobilePhone;
            $scope.pageIsDirty();
        };

        // Get Office Code
        $scope.getOfficeCode = function (employeeLocation) {
            if (!$scope.employeeXrefLocations) return;

            return _.find($scope.employeeXrefLocations, { EmployeeLocation: employeeLocation }).OfficeCode;
        }

        // Get Location To Display
        $scope.getLocationToDisplay = function (employeeLocation) {
            if (!$scope.employeeXrefLocations) return;

            return _.find($scope.employeeXrefLocations, { EmployeeLocation: employeeLocation }).displayName;
        }

        // Get Address
        $scope.getAddress = function (employeeLocation) {
            if (!$scope.employeeXrefLocations) return;

            return _.find($scope.employeeXrefLocations, { EmployeeLocation: employeeLocation }).Address;
        }
    }
})();